import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { NbAuthService } from '@nebular/auth'
import { NbMenuService } from '@nebular/theme'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  userMenu = [
    { title: 'Profile' },
    { title: 'Log out', data: { action: 'logout' } },
  ]
  userPictureOnly = false
  user: any = {}
  isLogged = false

  constructor(
    private authService: NbAuthService,
    private router: Router,
    private menuService: NbMenuService
  ) {
    this.menuService.onItemClick().subscribe((event) => {
      const action = event.item.data?.action
      if (action === 'logout') {
        this.authService.logout('email').subscribe(() => {
          this.router.navigateByUrl('/auth')
        })
      }
    })

    this.authService.onAuthenticationChange().subscribe((auth) => {
      this.isLogged = auth

      if (auth) {
        this.user = { name: 'Nick Jones', picture: 'assets/images/nick.png' } // here we receive a payload from the token and assigns it to our `user` variable
        console.log('User is logged')
      } else {
        console.log('User is logged out')
        this.user = {}
        this.router.navigateByUrl('/auth')
      }
    })
  }
}
